import { render, staticRenderFns } from "./NamirniceTab.vue?vue&type=template&id=1b841df0"
import script from "./NamirniceTab.vue?vue&type=script&lang=js"
export * from "./NamirniceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports